import { resolveUserOrSelectedTenant } from "./UserPermissionsUtil";
import { AddressStatusEnum, CountryCode } from "../routes/app/api/Representation";
export class WaypointTransformer {
    static extractDeliveryWaypoint(consignment) {
        return {
            companyName: consignment.deliveryCompanyName,
            contactEmail: consignment.deliveryContactEmail,
            contactName: consignment.deliveryContactName,
            uhfChannelOffice: consignment.deliveryUhfChannelOffice,
            uhfChannelLoader: consignment.deliveryUhfChannelLoader,
            from: consignment.deliveryFrom,
            sourcedSenderReceiverId: consignment.deliverySourcedSenderReceiverId,
            contactTelephone: consignment.deliveryTelephone,
            to: consignment.deliveryTo,
            waypointId: consignment.deliveryWaypointId,
            waypointVersion: consignment.deliveryWaypointVersion,
            address: consignment.deliveryAddress
        };
    }
    static extractPickupWaypoint(consignment) {
        return {
            companyName: consignment.pickupCompanyName,
            contactEmail: consignment.pickupContactEmail,
            contactName: consignment.pickupContactName,
            uhfChannelOffice: consignment.pickupUhfChannelOffice,
            uhfChannelLoader: consignment.pickupUhfChannelLoader,
            from: consignment.pickupFrom,
            sourcedSenderReceiverId: consignment.pickupSourcedSenderReceiverId,
            contactTelephone: consignment.pickupTelephone,
            to: consignment.pickupTo,
            waypointId: consignment.pickupWaypointId,
            waypointVersion: consignment.pickupWaypointVersion,
            address: consignment.pickupAddress
        };
    }
    static extractFromConsignmentWaypointUpdateRequest(waypoint) {
        return {
            companyName: waypoint.companyName,
            contactEmail: waypoint.contactEmail,
            contactName: waypoint.contactName,
            uhfChannelOffice: waypoint.uhfChannelOffice,
            uhfChannelLoader: waypoint.uhfChannelLoader,
            sourcedSenderReceiverId: waypoint.sourcedSenderReceiverId,
            contactTelephone: waypoint.contactTelephone,
            waypointVersion: waypoint.version,
            address: AddressTransformer.responseFromRequest(waypoint.address, 0, AddressStatusEnum.VALIDATED)
        };
    }
    static extractFromDeliveryAddressRequest(request) {
        return {
            companyName: request.companyName,
            contactEmail: request.contactEmailCsv,
            contactName: request.contactName,
            uhfChannelOffice: request.uhfChannelOffice,
            uhfChannelLoader: request.uhfChannelLoader,
            sourcedSenderReceiverId: request.sourcedSenderReceiverId,
            contactTelephone: request.contactTelephone,
            address: request.address ? AddressTransformer.responseFromRequest(request.address, 0, AddressStatusEnum.VALIDATED) : AddressTransformer.emptyAddressResponse()
        };
    }
    static emptyWaypoint() {
        return {
            companyName: null,
            contactEmail: null,
            contactName: null,
            uhfChannelOffice: null,
            uhfChannelLoader: null,
            from: null,
            sourcedSenderReceiverId: null,
            contactTelephone: null,
            to: null,
            waypointId: null,
            waypointVersion: null,
            address: AddressTransformer.emptyAddressResponse()
        };
    }
}
export class AddressTransformer {
    static emptyAddressResponse() {
        return {
            id: 0,
            street: "",
            suburb: "",
            state: "",
            countryCode: CountryCode.AU,
            status: AddressStatusEnum.INVALID
        };
    }
    static responseFromRequest(addressRequest, id, status) {
        return {
            id: id,
            unitOrFlat: addressRequest.unitOrFlat,
            street: addressRequest.street,
            suburb: addressRequest.suburb,
            state: addressRequest.state,
            postcode: addressRequest.postcode,
            countryCode: addressRequest.countryCode,
            latitude: addressRequest.latitude,
            longitude: addressRequest.longitude,
            siteRadius: addressRequest.siteRadius,
            status: status
        };
    }
    static fromResponse(request) {
        if (!request) {
            return null;
        }
        return {
            unitOrFlat: request.unitOrFlat,
            street: request.street,
            suburb: request.suburb,
            state: request.state,
            postcode: request.postcode,
            countryCode: request.countryCode,
            latitude: request.latitude,
            longitude: request.longitude,
            siteRadius: request.siteRadius,
        };
    }
}
export class ConsignmentFreightTransformer {
    static requestFromResponse(response) {
        return {
            version: response?.version && response.version > 0 ? response.version : undefined,
            productId: response.productId,
            productReference: response.productReference,
            productDescription: response.productDescription,
            description: response.description,
            trackingCode: response.trackingCode,
            wasteRecordId: response.wasteRecordId,
            height: response.height,
            width: response.width,
            length: response.length,
            dimensionUnit: response.dimensionUnit,
            weight: response.weight,
            weightUnit: response.weightUnit,
            unitOfMeasure: response.unitOfMeasure,
            netUnitOfMeasure: response.netUnitOfMeasure,
            orderedQuantity: response.orderedQuantity,
            grossQuantity: response.grossQuantity,
            tareQuantity: response.tareQuantity,
            netQuantity: response.netQuantity
        };
    }
}
export function resolveDefaultSenderId(loggedInUser, selectedTenant) {
    // if the user has divisions, try and find the default sender ID there
    if (loggedInUser && loggedInUser.divisions && loggedInUser.divisions.length) {
        const firstDivisionWithDefaultSender = loggedInUser.divisions.find(it => !!it.defaultSenderId);
        if (firstDivisionWithDefaultSender) {
            return firstDivisionWithDefaultSender.defaultSenderId;
        }
    }
    // Fallback to the tenant's default sender ID
    //  && !this.state.consignment.pickup.sourceSenderReceiverId
    const tenant = resolveUserOrSelectedTenant(loggedInUser, selectedTenant);
    if (tenant && 'defaultSenderReceiver' in tenant && tenant.defaultSenderReceiver?.id) {
        return tenant.defaultSenderReceiver.id;
    }
    return null;
}
